// A row of mobius_data_connectors where source = 'shopify' (bpm-lambdas getAllShopifyAccounts).
export interface ShopifyAccountRow {
  company: string;
  // The store name: `acme` for acme.myshopify.com.
  account_id: string;
  account_name: string;
  enabled: boolean;
}

export type ExistingConnection = 'none' | 'enabled' | 'disabled' | 'disabled_other_company';

// Note shown with a new link, by what installing it will do. `none` needs no note.
export const EXISTING_CONNECTION_NOTES: Record<ExistingConnection, string | undefined> = {
  none: undefined,
  enabled: 'Already connected: installing again replaces its token',
  disabled: 'This store is disabled: installing will re-enable it',
  disabled_other_company:
    'This store was connected to another company: installing will move it here'
};

// Response of bpm-lambdas beginShopifyInstall.
export interface ShopifyInstallLink {
  // The store name: `acme` for acme.myshopify.com.
  store: string;
  installUrl: string;
  // What installing will do to the store's existing connector.
  existingConnection: ExistingConnection;
  // ISO timestamp after which the callback rejects this link.
  expiresAt: string;
}

// How long an install link stays valid. Mirrors STATE_TTL_MS (7 days) in bpm-lambdas
// misc/shopifyAuthorization.ts; the link's own expiresAt is the source of truth once generated.
export const INSTALL_LINK_VALID_DAYS = 7;
